import { render, staticRenderFns } from "./AdminTransactions.vue?vue&type=template&id=aa982c6e"
import script from "./AdminTransactions.vue?vue&type=script&lang=js"
export * from "./AdminTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports